import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export async function getAssociates(params) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/associates`, {
      params,
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch associates');
  }
}

export async function getAssociateCredentials(params) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/associates/credentials`, {
      params,
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch associate credentials');
  }
}

export async function getAssociateProfile() {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/associates/profileDetail`, { headers });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch associate profile');
  }
}

export async function updateAssociate(id, data) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.put(`${API_BASE}/api/associates/${id}`, data, { headers });
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to update associate');
  }
}

export async function getAssociateCommissions(params) {
  try {
    const response = await axios.get(`${API_BASE}/api/associate-commissions`, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch associate commissions');
  }
}

export async function updateAssociateCommission(id, commission) {
  try {
    const response = await axios.put(
      `${API_BASE}/api/associate-commissions/${id}`,
      { commission },
      { headers: { 'Content-Type': 'application/json' } },
    );
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error(error.response?.data?.message || 'Failed to update associate commission');
  }
}

export async function saveAssociateCommission(data) {
  try {
    const response = await axios.post(`${API_BASE}/api/associate-commissions`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error(error.response?.data?.message || 'Failed to save associate commission');
  }
}

export async function createAssosciate(data) {
  try {
    const response = await axios.post(`${API_BASE}/api/associates`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create associate');
  }
}

export async function getTransferRecords(params = {}) {
  try {
    const response = await axios.get(`${API_BASE}/api/change-associates`, { params });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to fetch transfer records');
  }
}

export async function transferAssociate(data) {
  try {
    const response = await axios.post(`${API_BASE}/api/change-associates`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error('Failed to transfer associate');
  }
}

export async function getAssociateLedger(params = {}) {
  try {
    const response = await axios.get(`${API_BASE}/api/AssociateLedger`, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch associate ledger');
  }
}

export async function getAssociateLedgerReport(associateId, params = {}) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/AssociateLedger/report`, {
      params: { associateId, ...params },
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch associate ledger report');
  }
}

export async function createAssociateLedger(data) {
  try {
    const response = await axios.post(`${API_BASE}/api/AssociateLedger`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error(error.response?.data?.message || 'Failed to create associate ledger entry');
  }
}

export async function getCommissionBySponsor(sponsorId, params) {
  try {
    const response = await axios.get(`${API_BASE}/api/CommissionGenerator/sponsor/${sponsorId}`, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch commissions');
  }
}

export async function getSelfBusinessMetrics(associateId) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/CommissionGenerator/self-business/${associateId}`, { headers });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch self business metrics');
  }
}

export async function getPaymentAssociates(params = {}) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/IncentiveGenerator/payment-associates`, {
      params,
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch payment associates');
  }
}

export async function payIncentive(data) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.post(`${API_BASE}/api/IncentiveGenerator/payment`, data, {
      headers
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw new Error(error.response?.data?.message || 'Failed to process incentive payment');
  }
}

export async function getPaymentEntries(params = {}) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/IncentiveGenerator/payment-entries`, {
      params,
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch payment entries');
  }
}

export async function saveIncentivePayment(payload) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.post(`${API_BASE}/api/IncentiveGenerator/payment`, payload, {
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to save incentive payment');
  }
}

export async function resendWelcomeSms(associateId) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const response = await axios.post(
      `${API_BASE}/api/associates/${associateId}/resend-welcome-sms`,
      {},
      { headers }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send SMS');
  }
}